export default __webpack_public_path__ + "static/media/rabbit-gun-2.caa3adaf.png";